import { shopPrefix } from '../../config';
import { CopiesListOut } from '../../store/api';
import { http } from '../../api/axios';

const FETCH_CART_ITEM_COPIES_URL = `${shopPrefix}/v1/shoppingcart/products/:productId`;

export const fetchCartItemsCopies = (productId: string): Promise<CopiesListOut> => {
    return http
        .get<CopiesListOut>(FETCH_CART_ITEM_COPIES_URL, {
            pathParams: { productId }
        })
        .then(response => ({ copies: response.data.copies ?? [] }));
};
